import React, { useState } from "react";
import { Share2, Check } from "lucide-react";
import { api } from "../lib/api";
import { useToast } from "../hooks/use-toast";
import { fmtPoints } from "../data/mock";
import { log } from "../lib/log";

export default function ShareButton({ deal, variant = "icon", className = "" }) {
  const { toast } = useToast();
  const [copied, setCopied] = useState(false);

  const share = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const id = await api.shareDeal(deal);
      const url = `${window.location.origin}/deal/${id}`;
      const text = `${deal.origin.code} → ${deal.destination.code} in ${deal.cabin} for ${fmtPoints(deal.points)} pts on ${deal.airline}`;
      if (navigator.share) {
        try { await navigator.share({ title: "FindMyFlight deal", text, url }); return; } catch (err) {
          if (err?.name === "AbortError") return; // user dismissed the share sheet
          log.warn("Native share unavailable, copying link instead", err);
        }
      }
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      toast({ title: "Link copied", description: "Share it with friends — it opens this exact flight." });
    } catch (err) {
      log.error("Failed to create share link", err);
      toast({ title: "Could not create share link", variant: "destructive" });
    }
  };

  if (variant === "button") {
    return (
      <button onClick={share} data-testid="share-deal-button" className={`inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:border-blue-300 hover:text-blue-600 ${className}`}>
        {copied ? <Check className="h-4 w-4 text-green-600" /> : <Share2 className="h-4 w-4" />}
        {copied ? "Copied!" : "Share deal"}
      </button>
    );
  }
  return (
    <button onClick={share} aria-label="Share deal" data-testid="share-deal-icon" className={`flex min-h-9 items-center gap-1 px-1 text-xs font-semibold text-slate-500 transition-colors hover:text-blue-600 ${className}`}>
      {copied ? <Check className="h-3.5 w-3.5 text-green-600" /> : <Share2 className="h-3.5 w-3.5" />}
      {copied ? "Copied" : "Share"}
    </button>
  );
}
